import { CloseEditorIfOpenedEvent } from 'modules/application/detail/portal-submodule-builder/templates/builder/BuilderController';
import { ProcessHttpActionSettings } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/ProcessHttpActionSettings';
import { ActionController } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/actions/ActionController';
import { SourceSyntax, TextEditorController } from 'modules/ui/textEditorModal/TextEditorController';
import TextEditorModalView from 'modules/ui/textEditorModal/TextEditorModalView.html';
import { HttpVerbs } from 'types/HttpVerbs';
import { VARIABLE_VALIDATION_REGEX } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/Validator';
import '../Actions.scss';
const defaultBodyObject = {
    firstName: 'John',
    lastName: 'Doe',
};
export class ProcessHttpActionController extends ActionController {
    static $inject = ['close', 'action', '$onStateChanged', 'ModalService', '$translate', '$timeout', 'SidebarContentService', 'CodeEditorService', 'UndoRedoService', 'state', '$rootScope', '$scope', 'CurrentApplicationService', 'typeOfAction', 'onOpenSchemaEditor'];
    constructor(close, action, $onStateChanged, ModalService, $translate, $timeout, SidebarContentService, CodeEditorService, UndoRedoService, state, $rootScope, $scope, CurrentApplicationService, typeOfAction, onOpenSchemaEditor) {
        super(close, action, $onStateChanged, UndoRedoService, state, { $rootScope, $scope, typeOfAction, onOpenSchemaEditor });
        this.ModalService = ModalService;
        this.$translate = $translate;
        this.$timeout = $timeout;
        this.SidebarContentService = SidebarContentService;
        this.CodeEditorService = CodeEditorService;
        this.UndoRedoService = UndoRedoService;
        this.state = state;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.CurrentApplicationService = CurrentApplicationService;
        this.typeOfAction = typeOfAction;
        this.isEditing = false;
        this.httpMethods = [];
        this.isEditorOpened = false;
        this.init();
    }
    async init() {
        this.application = await this.CurrentApplicationService.fetchApplicationByStateParams();
        this.httpMethods = [
            { value: 'GET', label: 'GET' },
            { value: 'POST', label: 'POST' },
            { value: 'PUT', label: 'PUT' },
            { value: 'PATCH', label: 'PATCH' },
            { value: 'DELETE', label: 'DELETE' },
            { value: 'OPTIONS', label: 'OPTIONS' },
            { value: 'HEAD', label: 'HEAD' },
            { value: 'TRACE', label: 'TRACE' },
        ];
        this.processHttpForm.url.$setDirty();
        this.$scope.$watch('$ctrl.action.settings.uri', (oldValue, newValue) => {
            this.$timeout(this.checkURL.bind(this));
        });
        this.$scope.$watch('$ctrl.action.settings.responseBodyVariable', (oldValue, newValue) => {
            this.$timeout(this.checkResponseBodyVariable.bind(this));
        });
        this.$scope.$watch('$ctrl.action.settings.responseStatusVariable', (oldValue, newValue) => {
            this.$timeout(this.checkResponseStatusVariable.bind(this));
        });
        if (!this.action.conditions) {
            this.action.conditions = [];
        }
        this.addEventOnMethodField();
    }
    create() {
        return new ProcessHttpActionSettings();
    }
    checkURL() {
        const setUrlValidity = (isValid) => {
            this.processHttpForm.url.$invalid = !isValid;
            this.processHttpForm.url.$valid = isValid;
        };
        try {
            if (this.action.settings.uri &&
                (!this.action.settings.uri.match(/^((http|https):\/\/[^ "]+|\{\{[A-Za-z0-9\.@\[\]]+\}\}[^ "]*)$/))) {
                setUrlValidity(false);
                this.processHttpForm.url.$setDirty();
            }
        }
        catch (e) {
            console.error(e);
            setUrlValidity(false);
            this.processHttpForm.url.$setDirty();
        }
        this.save();
    }
    checkResponseStatusVariable() {
        const setResponseStatusVariableValidity = (isValid) => {
            this.processHttpForm.responseStatusVariable.$invalid = !isValid;
            this.processHttpForm.responseStatusVariable.$valid = isValid;
        };
        try {
            if (this.action.settings.responseStatusVariable &&
                this.checkRegexVariable(this.action.settings.responseStatusVariable)) {
                setResponseStatusVariableValidity(false);
                this.processHttpForm.responseStatusVariable.$setDirty();
            }
        }
        catch (e) {
            console.error(e);
            setResponseStatusVariableValidity(false);
            this.processHttpForm.responseStatusVariable.$setDirty();
        }
        this.save();
    }
    checkResponseBodyVariable() {
        const setResponseBodyVariableValidity = (isValid) => {
            this.processHttpForm.responseBodyVariable.$invalid = !isValid;
            this.processHttpForm.responseBodyVariable.$valid = isValid;
            this.processHttpForm.responseBodyVariable.$setDirty();
        };
        try {
            if (this.action.settings.responseBodyVariable &&
                this.checkRegexVariable(this.action.settings.responseBodyVariable)) {
                setResponseBodyVariableValidity(false);
            }
        }
        catch (e) {
            console.error(e);
            setResponseBodyVariableValidity(false);
        }
        this.save();
    }
    checkRegexVariable(val) {
        return !(VARIABLE_VALIDATION_REGEX.test(val));
    }
    onBlur() {
        this.isEditing = false;
        if (this.action.$title.length === 0) {
            this.action.$title = this.$translate.instant('builder-tabs-actions.processHttp.title');
            this.save();
        }
    }
    changeMethod() {
        if (this.isEditorOpened && !this.hasBody(this.action.settings.method)) {
            this.closeEditor();
        }
        if (this.hasBody(this.action.settings.method)) {
            if (!this.action.settings.body) {
                this.action.settings.body = JSON.stringify(defaultBodyObject, undefined, 4);
            }
        }
        else {
            this.action.settings.body = undefined;
        }
        this.save();
    }
    closeEditor() {
        this.SidebarContentService.cleanAndClose(false, this.sidebarEditor);
        this.isEditorOpened = false;
        this.sidebarEditor = undefined;
    }
    toggleCodeEditor() {
        switch (this.isEditorOpened) {
            case true:
                this.closeEditor();
                break;
            case false:
                this.openCodeEditor();
                this.isEditorOpened = true;
                break;
        }
    }
    async openCodeEditor() {
        this.sidebarEditor = await this.CodeEditorService.openCodeEditor({
            code: this.action.settings.body,
            language: 'json',
            editorWasCreated: this.editorWasCreated.bind(this),
            SidebarContentService: this.SidebarContentService,
            onCodeEditorChange: ({ code }) => {
                this.action.settings.body = code;
            },
            onSaveSource: () => {
                this.save();
            },
        });
        const deregisterCloseEditorEvent = this.$rootScope.$on(CloseEditorIfOpenedEvent, () => {
            this.SidebarContentService.cleanAndClose(false, this.sidebarEditor);
        });
        await this.sidebarEditor.closeDeferred.promise; // when code editor close
        deregisterCloseEditorEvent();
        this.isEditorOpened = false;
    }
    editorWasCreated({ editor }) {
        this.isMonacoLoading = false;
        setTimeout(() => {
            // Time to sidebar animation
            editor.layout();
        }, 500);
    }
    startEditing() {
        const input = document.getElementById('process-http-title');
        if (input) {
            input.focus();
        }
    }
    errorOnAdd() {
        console.error('Could not add a new key');
    }
    hasBody(method) {
        return (method &&
            method != HttpVerbs.GET &&
            method != HttpVerbs.DELETE &&
            method != HttpVerbs.TRACE &&
            method != HttpVerbs.HEAD &&
            method != HttpVerbs.OPTIONS);
    }
    async openEditorModal() {
        let source = this.action.settings.body;
        const modal = await this.ModalService.showModal({
            template: TextEditorModalView,
            controller: TextEditorController,
            controllerAs: '$ctrl',
            inputs: {
                source,
                syntax: SourceSyntax.Text,
            },
        });
        source = await modal.close;
        if (source) {
            this.action.settings.body = source;
        }
    }
    addEventOnMethodField() {
        document.querySelector('.sidebar-default-form #method')
            .addEventListener('bdsChange', ({ detail: { value } }) => {
            this.action.settings.method = value;
            this.changeMethod();
        });
    }
    get method() {
        return this.action.settings.method;
    }
    set method(value) {
        this.isDeepChange = true;
        this.action.settings.method = value;
    }
}
ProcessHttpActionController.$inject = ['close', 'action', '$onStateChanged', 'ModalService', '$translate', '$timeout', 'SidebarContentService', 'CodeEditorService', 'UndoRedoService', 'state', '$rootScope', '$scope', 'CurrentApplicationService', 'typeOfAction', 'onOpenSchemaEditor'];
